import { Skeleton, Stack, styled } from "@mui/material";
import React from "react";

const NotifCardItem = styled(Skeleton)(
    ({ theme }) => `
        width: 100%;
        height: 97px;
        borderRadius: 8px; 
    `
)


export function NotifCardLoader() {

    return (
        <Stack spacing={2} sx={{width: "100%"}}>
            <NotifCardItem variant="rounded" />
            <NotifCardItem variant="rounded" />
            <NotifCardItem variant="rounded" />
            <NotifCardItem variant="rounded" />
        </Stack>
    )
}

